
<template>
  <div>
    <router-view/>
    <chat-widget/>
  </div>
</template>

<script>
import ChatWidget from '@/components/common/ChatWidget.vue'
export default {
  name: 'App',
  components: {
    ChatWidget,
  },
}
</script>
<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
}

.caution {
  color: #ffa000;
}

.error {
  color: #e53935;
}
</style>
